import * as React from "react";
import ShiftMappingList from "../../presentations/ShiftMappingList";

const ShiftMappingListContainer = (props: any) => {

  const { onEdit } = props;

  const handleOnEdit = (rowData: any) => {
    console.log('on edit group list container ---');
    console.log(rowData);
    onEdit(rowData);
  }


  return (
    <div>
      <ShiftMappingList onEdit={handleOnEdit}></ShiftMappingList>
    </div>
  );
};

export default ShiftMappingListContainer;
